module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "availableRooms"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.date, "dddd D. MMMM YYYY")))])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.types), function(type) {
    return _c('tr', {
      key: type.id
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_vm._v("\n                            " + _vm._s(type.title) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6 text-right"
    }, [(_vm.availableRooms[type.id] !== undefined) ? [_vm._v("\n                                " + _vm._s(_vm.availableRooms[type.id]) + " room(s)\n                            ")] : _vm._e()], 2)])
  }), 0)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6800e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rooms/AvailableRooms.vue
// module id = 391
// module chunks = 1